export default __webpack_public_path__ + "static/media/musical-note-variant-with-thin-outline-svgrepo-com.884e2fed.svg";